import {
  InfoPanelTitle,
  InfoPanelDescription,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function ActiveParticipationInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is active participation?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Tell us if you were actively involved in running this business during
          this year. This means you took part in the regular, day-to-day
          operations.
        </p>
      </InfoPanelDescription>
    </>
  )
}
